import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchDocumentCategoriesAsync,
  fetchDocumentsAsync,
} from "./documentsApi";
import merge from "lodash.merge";
import { currentEstateSelectors } from "../estate/currentEstate/currentEstateSlice";
import { documentSelectors } from "./documentsSlice";

export const fetchDocumentsThunk = createAsyncThunk(
  "documents/fetchDocuments",
  async (options, thunkAPI) => {
    const state = thunkAPI.getState();
    const { id } = currentEstateSelectors.selectCurrentEstate(state);
    const textSearch = documentSelectors.selectTextSearch(state);
    // add estateId to options
    const defaultOptions = {
      params: {
        filter: {
          estateId: id,
          fulltext: textSearch ? textSearch : "",
        },
      },
    };
    const mergedOptions = merge(defaultOptions, options);
    const response = await fetchDocumentsAsync(mergedOptions);
    const documents = response.data;

    return documents;
  },
);

export const fetchDocumentCategoriesThunk = createAsyncThunk(
  "documents/fetchCategories",
  async (options, thunkAPI) => {
    const response = await fetchDocumentCategoriesAsync(options);
    return response.data;
  },
);
